
export default class Translations {
    static languageCode = "";
    static langCode = "";
    static translated = "";

    setTranslationsUsingLanguageCode() {
      let langCode = Routing.getLanguageCodeFromPathName();
      Translations.languageCode = langCode;

      if (!b2.translations.hasOwnProperty(langCode)) {
          langCode = "en";
      }
      
      b2.translated = b2.translations[langCode];
    }
}

globalThis.Translations = Translations;

